export default {
  props: {
    platform: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      authDropdownOpen: false,
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    toggleAuthDropdown() {
      this.authDropdownOpen = !this.authDropdownOpen
    },
    handleOutsideClick(event) {
      if (!event.target.closest('.auth-actions')) {
        this.authDropdownOpen = false
      }
    },
    getDataAttributes(item) {
      const attrs = { ...item }
      if (attrs.eventGA) {
        Object.keys(attrs.eventGA).forEach((key) => {
          attrs[`data-${key.replace(/_/g, '-')}`] = attrs.eventGA[key]
        })
        delete attrs.eventGA
      }

      return attrs
    },
  },
}
